import { ReactComponent as ArrowNextIcon } from './next.svg';

export default ArrowNextIcon;
